module.exports = __webpack_public_path__ + "img/1515029320.dfab336d.jpg";